import React, { useState, useEffect } from 'react';
import { Shield, ThumbsUp, Truck, MessageCircle } from 'lucide-react';
import { mockFeatures } from '../mockData';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const iconMap = {
  'shield': Shield,
  'thumbs-up': ThumbsUp,
  'truck': Truck,
  'message-circle': MessageCircle
};

const Features = () => {
  const [title, setTitle] = useState('Truckn Send It is the easiest and safest way to move your load');

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/cms/content/features`);
      if (response.data.main_title?.value) {
        setTitle(response.data.main_title.value);
      }
    } catch (error) {
      console.log('Using default features content');
    }
  };

  return (
    <div className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-[#1e3a5f] mb-3 sm:mb-4 px-4">
          {title}
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 mt-8 sm:mt-12 max-w-6xl mx-auto">
          {mockFeatures.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div key={index} className="text-center px-4">
                <div className="flex justify-center mb-4">
                  <div className="bg-red-100 p-4 rounded-full">
                    <IconComponent className="w-7 h-7 sm:w-8 sm:h-8 text-red-600" />
                  </div>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-[#1e3a5f] mb-3">{feature.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-4 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Features;